import { render, staticRenderFns } from "./FranqueadoAprovado.vue?vue&type=template&id=51186a26&scoped=true"
import script from "./FranqueadoAprovado.vue?vue&type=script&lang=js"
export * from "./FranqueadoAprovado.vue?vue&type=script&lang=js"
import style0 from "./FranqueadoAprovado.vue?vue&type=style&index=0&id=51186a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51186a26",
  null
  
)

export default component.exports